import styled from 'styled-components';
export const StyledMegalogo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .megalogo-top {
    width: 28.75rem;
  }

  .megalogo-mid {
    width: 34.75rem;
  }

  .megalogo-bottom {
    width: 16.25rem;
  }

  .megalogo-button-container {
    max-width: 24rem;
    padding: 2rem;
    width: 100%;
  }

  .megalogo-button-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    .megalogo-top {
      width: 14rem;
    }

    .megalogo-mid {
      width: 17rem;
    }

    .megalogo-bottom {
      width: 8rem;
    }

    .megalogo-button-container {
      max-width: 18rem;
      padding: 1rem;
      width: 100%;
    }
  }
`;
